export default "__VITE_ASSET__BxkjMMUu__"